import React from 'react';
import {
  OPEN_COOKIE_PREFERENCES_EVENT,
  hasGlobalPrivacyControl,
  needsConsentDecision,
  readConsent,
  saveConsent,
} from '../lib/consent';
import './CookieConsentBanner.css';

function CookieConsentBanner() {
  const [open, setOpen] = React.useState(() => needsConsentDecision());
  const [isPreferences, setIsPreferences] = React.useState(false);
  const acceptRef = React.useRef(null);

  React.useEffect(() => {
    function handleOpen() {
      setIsPreferences(true);
      setOpen(true);
    }
    window.addEventListener(OPEN_COOKIE_PREFERENCES_EVENT, handleOpen);
    return () => window.removeEventListener(OPEN_COOKIE_PREFERENCES_EVENT, handleOpen);
  }, []);

  React.useEffect(() => {
    if (open && isPreferences && acceptRef.current) acceptRef.current.focus();
  }, [open, isPreferences]);

  if (!open) return null;

  const current = readConsent();
  const gpc = hasGlobalPrivacyControl();

  function choose(analytics) {
    saveConsent({ analytics });
    setOpen(false);
    setIsPreferences(false);
  }

  return (
    <section
      className="cookie-banner"
      aria-labelledby="cookie-banner-title"
      aria-describedby="cookie-banner-body"
    >
      <div className="cookie-banner-inner">
        <div className="cookie-banner-copy">
          <h2 id="cookie-banner-title" className="cookie-banner-title">
            {isPreferences ? 'Cookie preferences' : 'Cookies on this site'}
          </h2>
          <p id="cookie-banner-body" className="cookie-banner-body">
            We use essential cookies and browser storage to keep the site and client portal working.
            Until you choose, Google Analytics counts page and calculator visits without cookies or
            visitor IDs. If you allow analytics, it also uses cookies to recognize return visits. Declining
            stops both. We do not use advertising cookies or sell your information.{' '}
            <a href="/privacy-policy#cookies">Learn more</a>
          </p>
          {isPreferences && current ? (
            <p className="cookie-banner-status">
              Current setting: analytics {current.analytics ? 'allowed' : 'declined'}.
            </p>
          ) : null}
          {isPreferences && !current && gpc ? (
            <p className="cookie-banner-status">
              Your browser sent a Global Privacy Control signal, so analytics is off.
            </p>
          ) : null}
        </div>
        <div className="cookie-banner-actions">
          <button type="button" className="cookie-banner-btn" onClick={() => choose(false)}>
            Decline analytics
          </button>
          <button
            type="button"
            ref={acceptRef}
            className="cookie-banner-btn"
            onClick={() => choose(true)}
          >
            Allow analytics
          </button>
          {isPreferences ? (
            <button
              type="button"
              className="cookie-banner-close"
              onClick={() => {
                setOpen(false);
                setIsPreferences(false);
              }}
              aria-label="Close cookie preferences"
            >
              ×
            </button>
          ) : null}
        </div>
      </div>
    </section>
  );
}

export default CookieConsentBanner;
